import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["panel"]

  closeOnOutsideClick(event) {
    this.panelTargets.forEach((panel) => {
      if (panel.open && !panel.contains(event.target)) {
        panel.removeAttribute("open")
      }
    })
  }
}